// 导入
import request from '@/utils/request.js'
import qs from "qs"

// 用户登录请求
function Login(data) {
	// 返回的是一个promise实例
	// return axios .post(/api/login)
	return request.post('/openApi/faUser/login', data);
}

// 一.找up主模块
// 1.up主检索页面
function Search(data) {
	return request.post('/v1/Blogger/Search', data)
}

// 2.up主排行数据
function GetScreen() {
	return request.get('/v1/Blogger/BloggerCategory?r=0.9375642037746112')
}

function GetUpInfo(data) {
	return request.post('/v1/Blogger/Search', data)
}
// 2.up主排行数据结束
// 搜索接口
function getSearch(data){
	return request(	`/v1/home/search?${qs.stringify(data)}`)
}

// 导出接口
export {
	Login,
	Search,
	GetScreen,
	GetUpInfo,
	getSearch
}
